import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, ViewChild } from '@angular/core';
import { StepsModule } from 'primeng/steps';
import { MenuItem } from 'primeng/api';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { Router, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SimplePdfViewerComponent, SimplePDFBookmark } from 'simple-pdf-viewer';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { StoreService } from '../store.service';
import * as moment from 'moment';
import { element } from 'protractor';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-doc-edit',
  templateUrl: './doc-edit.component.html',
  styleUrls: ['./doc-edit.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, ConfirmationService]
})
export class DocEditComponent implements OnInit {
  msgs: Message[] = [];
  loadingMessage: any = "Loading...";
  documentID: any = 0;
  qboVendor: SelectItem[] = [];
  qboVendorTemp: any = [];
  qboDocumentLinesEdit: any = [];
  documentVendor: "";
  billingAddress = "";
  reportViaTPAR = false;
  billNumber = "";
  invoiceNumber = "";
  invoiceDate:Date;
  documentMemo="";
  dueDate:Date;
  isAccountDetail: boolean = true;
  isItemDetail: boolean = false;
  connectCompanyMessage: string = "";
  isJob: boolean = false;
  isClass: boolean = false;
  saveClicked: boolean = false;
  scanBlobUrl = "";

  editTotal: any = 0;
  editSubTotal: any = 0;
  editGstTotal: any = 0;


  qboaccount: SelectItem[] = [];
  qboaccountsTemp: any = [];

  qboitems: SelectItem[] = [];
  qboitemsTemp: any = [];

  qboCustomers: SelectItem[] = [];
  qboCustomerTemp: any = [];

  qboClass: SelectItem[] = [];
  qboClassTemp: any = [];

  constructor(private router: Router, private api: ApiService, private http: HttpClient,
    private spinner: NgxSpinnerService, private ss: StoreService,
    private confirmationService: ConfirmationService, private route: ActivatedRoute) {


    var rahSetting = this.ss.fetchAccountRahMaster();


  }

  ngOnInit() {

    this.initLoad();
    
  }


  initLoad() {

    this.spinner.show();
    this.loadingMessage = "Loading...";
    this.validateConnectCompany();
    this.documentID = this.route.snapshot.params['id'];

    this.bindCustomers();

    this.getClass();
    this.bindVendors();
    this.bindAccount();
    this.bindItem();

    this.getUpdatedDocument(this.documentID);

  }

  
  validateConnectCompany() {

    this.api.get('Rah/GetByAccountID', '').subscribe(
      (res: {}) => this.sucessQboMaster(res),
      error => this.failedQboMaster(<any>error));

  }

  failedQboMaster(res: any) {
    this.spinner.hide();
  }

  sucessQboMaster(res: any) {
    // this.spinner.hide();
    if (res.StatusCode == 0) {

      var companyName = res.Data[0].CompanyName;
      if (companyName == '' || companyName == null) {
        this.connectCompanyMessage = "No company is connected, Connect a company from Switch Company menu";
      }
      this.isJob = res.Data[0].IsJob;
      this.isClass = res.Data[0].IsClass;
      this.isAccountDetail = res.Data[0].IsAccountDetail;
      this.isItemDetail = res.Data[0].IsItemDetail;
    }
  }

  bindVendors() {

    this.qboVendorTemp = this.ss.fetchQboVendors();
    this.qboVendor.push({ label: '', value: '' });

    if (this.qboVendorTemp == null) return;

    this.qboVendorTemp.forEach(element => {
      this.qboVendor.push({ label: element.FullName, value: element.ListID });
    });
  }
  bindCustomers() {
    this.qboCustomerTemp = this.ss.fetchQboCustomers();
    this.qboCustomers.push({ label: '', value: '' });

    if (this.qboCustomerTemp == null) return;

    this.qboCustomerTemp.forEach(element => {
      this.qboCustomers.push({ label: element.FullName, value: element.ListID });
    });
  }


  bindAccount() {
    
    this.qboaccountsTemp = this.ss.fetchQboAccount();
    this.qboaccount.push({ label: '', value: '' });
    if (this.qboaccountsTemp == null) return;

    this.qboaccountsTemp.forEach(element => {
      this.qboaccount.push({ label: element.FullName, value: element.ListID });
    });
  }

  bindItem() {
    this.qboitemsTemp = this.ss.fetchQboItem();
    this.qboitems.push({ label: '', value: '' });
    if (this.qboitemsTemp == null) return;

    this.qboitemsTemp.forEach(element => {
      this.qboitems.push({ label: element.FullName, value: element.ListID });
    });
  }
  getClass() {

    this.api.get('Rah/GetQboClass', '').subscribe(
      (res: {}) => this.success_getClass(res),
      error => this.failed_getClass(<any>error));

  }

  success_getClass(resp: any) {

    if (resp) {

      this.qboClassTemp = resp.Data;
      this.qboClass.push({ label: '', value: '' });

      if (this.qboClassTemp == null) return;

      this.qboClassTemp.forEach(element => {
        this.qboClass.push({ label: element.FullName, value: element.ListID });
      });

    }

  }

  failed_getClass(resp: any) {

  }

  getUpdatedDocument(value: any) {

    this.spinner.show();
    this.loadingMessage = "Processing...";
    this.api.get('Scan/GetUpdatedDocument?DocumentID=', value).subscribe(
      (res: {}) => this.successGetDocument(res),
      error => this.failedtoGetDocument(<any>error));

  }
  successGetDocument(resp: any) {
    
    this.spinner.hide();
    this.qboDocumentLinesEdit = resp.Data;

    this.qboDocumentLinesEdit.forEach(element => {
      var selectedTax = 0;
      if (element.ScanGST > 0) {
        selectedTax = (element.ScanGST * 100 / element.Scan_Total)
        element.ScanTax = Math.round(selectedTax * 10) / 10;

      }
      else
        element.ScanTax = 0;

    });



    this.documentVendor = this.qboDocumentLinesEdit[0].QboCustListID;
    this.billingAddress = this.qboDocumentLinesEdit[0].ShippingTo;
    this.billNumber = this.qboDocumentLinesEdit[0].ScanABNNumber;
    this.invoiceNumber = this.qboDocumentLinesEdit[0].ScanRefNumber;
    this.invoiceDate = this.qboDocumentLinesEdit[0].ScanInvoiceDate;
    this.scanBlobUrl = this.qboDocumentLinesEdit[0].ScanBlob_Url;
    this.documentMemo=this.qboDocumentLinesEdit[0].Memo;
    this.editTotal = this.qboDocumentLinesEdit[0].ScanInvoiceTotal;
    this.editGstTotal = this.qboDocumentLinesEdit[0].ScanTaxTotal;
    this.editSubTotal = this.qboDocumentLinesEdit[0].ScanSubTotal;

   var date = new Date(this.invoiceDate);
   date.setDate(date.getDate() + this.qboDocumentLinesEdit[0].DueDays);

    this.dueDate=date;
   // this.CalculateTotal();
  }
  failedtoGetDocument(error: any) {
    this.spinner.hide();

    console.log(error);
  }
  onChangeBillNumber() {
    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanABNNumber = this.billNumber;

    });
    this.billNumber = this.qboDocumentLinesEdit[0].ScanABNNumber;
  }
  onChangeInvoiceNumber() {
    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanRefNumber = this.invoiceNumber;

    });
    this.invoiceNumber = this.qboDocumentLinesEdit[0].ScanRefNumber;
  }
  onChangeInvoiceDate(record: any) {

    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanInvoiceDate = record

    });
    this.invoiceDate = this.qboDocumentLinesEdit[0].ScanInvoiceDate;
    var date = new Date(this.invoiceDate);
    date.setDate(date.getDate() + this.qboDocumentLinesEdit[0].DueDays);
 
     this.dueDate=date;
  }
  onChangeDueDate(record: any) {
    var date1 = new Date(this.invoiceDate); 
    var date2 = new Date(record); 
    var Difference_In_Time = date2.getTime() - date1.getTime(); 
    var Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24)); 

    this.qboDocumentLinesEdit.forEach(element => {
      element.DueDays = Difference_In_Days;

    });
    this.dueDate=new Date(record);
  }
  saveEditChanges() {
    this.msgs = [];
    this.qboDocumentLinesEdit.forEach(element => {
      element.Memo = this.documentMemo;

    });
   
    if(this.invoiceNumber==""){
      this.msgs.push({ severity: 'error', summary: 'Supplier Invoice Number is a required field', detail: 'Mandatory Field' });
   return;
    }
    if(this.invoiceDate==null){
      this.msgs.push({ severity: 'error', summary: 'Invoice Date is a required field', detail: 'Mandatory Field' });
   return;
    }
    if(this.documentVendor==""){
      this.msgs.push({ severity: 'error', summary: 'Supplier is a required field', detail: 'Mandatory Field' });
   return;
    }
    var newRecord = this.qboDocumentLinesEdit.filter(a => a.DocumentLineID == 0);
    if (newRecord.length > 0 && (newRecord[0].ScanDescription == '' || newRecord[0].Scan_Quantity == 0 || newRecord[0].ScanUnit_Price == 0)) {
      Swal.fire('','Please fill all required data in newly added line','error');

      //alert("Please fill all required data in newly added line");
    }
    else {
      if (this.saveClicked == false) {
        this.saveClicked = true;
        this.spinner.show();
        this.loadingMessage = "Processing...";
        console.log(this.qboDocumentLinesEdit);
        
        this.api.post('Rah/SaveQboDocumentEditChanges', this.qboDocumentLinesEdit).subscribe(
          (res1: {}) => this.successSaveEditChanges(res1),
          error => this.failedSaveEditChanges(<any>error));
      }
    }
  }

  onChangeAccount(event: any, record: any) {

    var acct = this.qboaccountsTemp.find(xx => xx.ListID == event.value);
    record.QboAccountName = acct.FullName;
    record.QboAccountListID = acct.ListID
    console.log('Item111');
    console.log(acct);


  }


  onChangeItem(event: any, record: any) {
    var acct = this.qboitemsTemp.find(xx => xx.ListID == event.value);
    record.QboItemName = acct.FullName;
    record.QboItemListID = acct.ListID
    console.log('Item111' + record.QboItemName);
    console.log(acct);

  }



  onChangeVendor(event: any) {


    var acct = this.qboVendorTemp.find(xx => xx.ListID == event.value);
    this.qboDocumentLinesEdit.forEach(element => {
      element.QboCustListID = acct.ListID;
      element.QboCustName = acct.FullName;
    });

  }

  onChangeCustomer(event: any, record: any) {


    var acct = this.qboCustomerTemp.find(xx => xx.ListID == event.value);
    record.QboJobID = acct.ListID;
    record.QboJobName = acct.FullName;

  }

  onChangeClass(event: any, record: any) {


    var acct = this.qboClassTemp.find(xx => xx.ListID == event.value);
    record.QboClassListID = acct.ListID;
    record.QboClassName = acct.FullName;

  }
  CalculateTotal() {
    var total = 0;
    var gstTotal = 0;
    var subTotal = 0;
    this.qboDocumentLinesEdit.forEach(element => {
      total = total + element.Scan_Total;
      gstTotal = gstTotal + element.ScanGST;
      subTotal = subTotal + element.Scan_Total;
    });

    this.qboDocumentLinesEdit.forEach(element => {
      element.ScanInvoiceTotal = total;
    });


    this.editTotal = total + gstTotal;
    this.editGstTotal = gstTotal;
    this.editSubTotal = subTotal;

  }

  onChangeTax(record: any) {

    console.log("Tax:" + record.ScanTax);
    record.Scan_Total = record.Scan_Quantity * record.ScanUnit_Price;
    //if (record.ScanTax > 0)
      record.ScanGST = ((record.Scan_Quantity * record.ScanUnit_Price) * 10) / 100;
    //else
      //record.ScanGST = 0;
    this.CalculateTotal();
  }

  onChangeQty(record: any) {
    record.Scan_Total = record.Scan_Quantity * record.ScanUnit_Price;
    //if (record.ScanTax > 0)
      record.ScanGST = ((record.Scan_Quantity * record.ScanUnit_Price) * 10) / 100;
    //else
      //record.ScanGST = 0;
    this.CalculateTotal();
  }

  onChangePrice(record: any) {

    record.Scan_Total = record.Scan_Quantity * record.ScanUnit_Price;
    //if (record.ScanTax > 0)
      record.ScanGST = ((record.Scan_Quantity * record.ScanUnit_Price) * 10) / 100;
    //else
      //record.ScanGST = 0;
    this.CalculateTotal();
  }

  successDeleteLineRecord(res: any, record: any) {
    this.spinner.hide();
    if (res.StatusCode == 0) {
      
      const index: number = this.qboDocumentLinesEdit.indexOf(record);
      console.log(index);
      this.qboDocumentLinesEdit.splice(index, 1);
      

      this.CalculateTotal();

      this.api.post('Rah/EditScanTotal', { 'DocumentID': this.documentID, 'ScanInvoiceTotal': this.editTotal }).subscribe(
        (res1: {}) => alert('Updated Successfully'),
        error => alert('Error in Update'));

    }

  }


  failedDeleteRecord(res: any) {
    this.spinner.hide();
    console.log("Failed to Delete");
  }

  deleteLineRecord(record) {
    console.log(record.DocumentLineID);
    if (confirm("Are you sure want to remove this line ?")) {
      if (record.DocumentLineID == 0) {
        
        const index: number = this.qboDocumentLinesEdit.indexOf(record);
        console.log(index);
        this.qboDocumentLinesEdit.splice(index, 1);



      } else {
        this.loadingMessage = "Delete to Record..";
        this.spinner.show();
        this.api.post('Rah/DeleteQboDocumentLine', { 'DocumentLineID': record.DocumentLineID }).subscribe(
          (res1: {}) => this.successDeleteLineRecord(res1, record),
          error => this.failedDeleteRecord(<any>error));
      }
    }

  }

  Cancel() {
    this.router.navigateByUrl("/docreview");
  }

  showPdf(value: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    this.http.get(this.api.apiBaseUrl + 'Scan/GetQbDocumentFile?qboDocumentID=' + value.DocumentID, { headers: headers, responseType: 'blob' }).subscribe(
      (res: {}) => this.sucessDocumentFile(res),
      error => this.failedDocumentFile(<any>error));
  }

  sucessDocumentFile(resp: any) {
 
    console.log('Array byte')
    console.log(resp)

    var file = new Blob([resp], { type: 'application/pdf' });
    var fileURL = URL.createObjectURL(file);
    const win = window.open(fileURL , 'View Pdf', 'width=800,height=700');

     win.focus();

  }

  // viewPdf(value: any) {

  //   this.api.get('Scan/GetQboDocumentFilePath?qboDocumentID=', value.DocumentID).subscribe(
  //     (res: {}) => this.sucessDocumentFilePath(res),
  //     error => this.failedDocumentFile(<any>error));

  // }
  // sucessDocumentFilePath(resp: any) {
  //   console.log(resp);
  //   const win = window.open(this.api.apiPreBaseUrl + resp, 'View Pdf', 'width=800,height=700');
  //   win.focus();
  //   console.log(resp);
  // }
  failedDocumentFile(resp: any) {

  }

  splitDocumeneLine(record: any) {

    var addFlag = 0;
    if (record.Scan_Quantity >= 2) {
      if (record.Scan_Quantity % 2 == 0)
        addFlag = 0;
      else
        addFlag = 1;

      var Qty1 = Math.floor(record.Scan_Quantity / 2);
      var Qty2 = Qty1 + addFlag;
      record.Scan_Quantity = Qty2;
      record.Scan_Total = Qty2 * record.ScanUnit_Price;
      record.ScanInvoiceTotal = record.ScanGST + (Qty2 * record.ScanUnit_Price);
      record.ScanGST = ((Qty2 * record.ScanUnit_Price) * 10) / 100

      var index = this.qboDocumentLinesEdit.indexOf(record);
      console.log(index);


      var splitedElement = {
        'DocumentID': this.qboDocumentLinesEdit[0].DocumentID,
        'DocumentLineID': 0,
        'Scan_Quantity': Qty1,
        'ScanUnit_Price': record.ScanUnit_Price,
        'ScanGST': ((Qty1 * record.ScanUnit_Price) * 10) / 100,
        'Scan_Total': Qty1 * record.ScanUnit_Price,
        'ScanInvoiceTotal': this.qboDocumentLinesEdit[0].ScanInvoiceTotal,
        'ScanDescription': record.ScanDescription,
        'QboAccountListID': record.QboAccountListID,
        'QboAccountName': record.QboAccountName,
        'QboItemListID': record.QboItemListID,
        'QboItemName': record.QboItemName,
        'QboJobID': record.QboJobID,
        'QboClassListID': record.QboClassListID,
        'ScanInvoiceDate': record.ScanInvoiceDate,
        'ScanTax': 10,
        'QboCustListID': record.QboCustListID,
        'QboCustName':record.QboCustName,
        'ScanABNNumber': record.ScanABNNumber,
        'ScanRefNumber': record.ScanRefNumber,
        'DueDays': record.DueDays,
        'Memo':record.Memo
      }

      this.qboDocumentLinesEdit.splice(index + 1, 0, splitedElement);



    }
    else {
    Swal.fire('','You can\'t split this element because it does not have sufficient quantity to split..','error');

      //alert("You can't split this element because it does not have sufficient quantity to split..");
    }

  }
  addNewLine() {

    var newRecord = this.qboDocumentLinesEdit.filter(a => a.DocumentLineID == 0 && a.ScanDescription == '' && a.Scan_Quantity == 0 && a.ScanUnit_Price == 0);
    if (newRecord.length > 0) {
    Swal.fire('','Please first fill all data in newly added line...','error');

     // alert("Please first fill all data in newly added line...");
    }

    else {
      var total = 0;
      var refNumber = '';
      var supplier = '';
      //var invoiceDate=this.qboDocumentLinesEdit[0].ScanInvoiceDate;

      this.qboDocumentLinesEdit.push(
        {
          'DocumentID': this.qboDocumentLinesEdit[0].DocumentID,
          'DocumentLineID': 0,
          'Scan_Quantity': 0,
          'ScanUnit_Price': 0.0,
          'ScanGST': 0.0,
          'Scan_Total': 0.0,
          'ScanInvoiceTotal': 0,
          'ScanDescription': "",
          'QboAccountListID': this.qboDocumentLinesEdit[0].QboAccountListID,
          'QboAccountName': this.qboDocumentLinesEdit[0].QboAccountName,
          'QboItemListID': this.qboDocumentLinesEdit[0].QboItemListID,
          'QboItemName': this.qboDocumentLinesEdit[0].QboItemName,
         // 'QboJobID': this.qboDocumentLinesEdit[0].QboJobID,
          //'QboClassListID': this.qboDocumentLinesEdit[0].QboClassListID,
          'ScanInvoiceDate': this.qboDocumentLinesEdit[0].ScanInvoiceDate,
          'QboCustListID': this.qboDocumentLinesEdit[0].QboCustListID,
          'QboCustName': this.qboDocumentLinesEdit[0].QboCustName,
          'ScanABNNumber': this.qboDocumentLinesEdit[0].ScanABNNumber,
          'DueDays': this.qboDocumentLinesEdit[0].DueDays,
          'ScanRefNumber': this.qboDocumentLinesEdit[0].ScanRefNumber,
           'ScanTax': 0,
           'Memo':this.qboDocumentLinesEdit[0].Memo

        });

      console.log(this.qboDocumentLinesEdit);



    }

  }

  successSaveEditChanges(res: any) {
    this.spinner.hide();
    this.saveClicked = false;
    if (res.StatusCode == 0) {
    Swal.fire('','Successfully updated invoice"','success');
    setTimeout(() => {
              
      this.router.navigateByUrl("/docreview");

      
     
    }, 1000);
      //alert("Successfully updated invoice");
     // this.getUpdatedDocument(this.documentID);
    }
    

  }
  failedSaveEditChanges(res: any) {
    this.spinner.hide();
    this.saveClicked = false;

    console.log("Error");
  }
}
